module.exports = __webpack_public_path__ + "img/sarmayeh.71ef8419.png";